import { useBreakpoint } from '../../../../../components/misc/Breakpoints/Breakpoints';

import { RESTRICTED_BOUNDS } from './coordinates';
import {
  CENTER, ZOOM,
} from './helpers';

const useResponsiveMapOptions = (fullScreen: boolean = false) => {
  const breakpoints = useBreakpoint();
  const mobileBreakpoint = breakpoints.maxWidth.breakpointMobile;
  const tabletBreakpoint = breakpoints.maxWidth.breakpointTablet;

  let zoom; let center; let latLngBounds;

  switch (true) {
    case mobileBreakpoint:
      zoom = fullScreen ? ZOOM.MOBILE.FULL_SCREEN : ZOOM.MOBILE.DEFAULT;
      center = fullScreen ? CENTER.MOBILE.FULL_SCREEN : CENTER.MOBILE.DEFAULT;
      latLngBounds = RESTRICTED_BOUNDS.MOBILE;
      break;
    case tabletBreakpoint:
      zoom = fullScreen ? ZOOM.TABLET.FULL_SCREEN : ZOOM.TABLET.DEFAULT;
      center = fullScreen ? CENTER.TABLET.FULL_SCREEN : CENTER.TABLET.DEFAULT;
      latLngBounds = RESTRICTED_BOUNDS.TABLET;
      break;
    default:
      zoom = ZOOM.DESKTOP;
      center = CENTER.DESKTOP;
      latLngBounds = RESTRICTED_BOUNDS.DESKTOP;
  }

  return { center, latLngBounds, zoom };
};

export default useResponsiveMapOptions;
